<div class="layout-content-container flex flex-col" [ngClass]="widthClass">
  <div class="flex h-full flex-col  p-4" [ngClass]="[containerBgClass, minHeightClass]">
    <!-- Menú -->
    <nav class="flex flex-col gap-2" role="navigation" aria-label="Main">
      @for (item of items; track item.path) {
        <div>
          <!-- Item principal -->
          <a
            (click)="onClick(item)"
            (keydown)="onKeydown($event, item)"
            [attr.tabindex]="item.disabled ? -1 : 0"
            [attr.aria-current]="isActive(item) ? 'page' : null"
            [attr.aria-disabled]="item.disabled ? 'true' : null"
            [attr.aria-expanded]="item.children && item.children.length > 0 ? isMenuOpen(item.path) : null"
            class="transition-all duration-200 rounded-lg mb-1 cursor-pointer select-none no-underline"
            [ngClass]="[
              isActive(item) ? activeItemClass : '',
              item.disabled ? 'opacity-50 cursor-not-allowed' : '',
              'flex items-center gap-3 px-3 h-10 w-full'
            ]"
            [attr.title]="item.disabled ? null : item.label"
          >
            <app-metro-icon [svg]="item.iconSvg" [color]="'#1C2D36'"></app-metro-icon>

            <!-- Label -->
            <span class="{{ textColorClass }} text-sm font-medium truncate flex-1">
              {{ item.label | abpLocalization }}
            </span>

            <!-- Icono de expansión para menús con hijos -->
            @if (item.children && item.children.length > 0) {
              <svg
                class="w-4 h-4 transition-transform duration-200"
                [ngClass]="isMenuOpen(item.path) ? 'rotate-180' : ''"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="#000000"
              >
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            }
          </a>

          <!-- Submenú (solo si tiene hijos y está abierto) -->
          @if (item.children && item.children.length > 0 && isMenuOpen(item.path)) {
            <div class="ml-8 mt-1 flex flex-col gap-1">
              @for (child of item.children; track child.path) {
                <a
                  (click)="onClick(child)"
                  (keydown)="onKeydown($event, child)"
                  [attr.tabindex]="child.disabled ? -1 : 0"
                  [attr.aria-current]="isActive(child) ? 'page' : null"
                  [attr.aria-disabled]="child.disabled ? 'true' : null"
                  class="transition-all duration-200 rounded-lg cursor-pointer select-none no-underline"
                  [ngClass]="[
                    isActive(child) ? activeItemClass : '',
                    child.disabled ? 'opacity-50 cursor-not-allowed' : '',
                    'flex items-center gap-3 px-3 h-10 w-full'
                  ]"
                  [attr.title]="child.disabled ? null : child.label"
                >
                  <app-metro-icon [svg]="child.iconSvg"  [color]="'#000000'"></app-metro-icon>

                  <!-- Label -->
                  <span class="{{ textColorClass }} text-sm font-medium truncate flex-1">
                    {{ child.label | abpLocalization }}
                  </span>
                </a>
              }
            </div>
          }
        </div>
      }
    </nav>
  </div>
</div>
